var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avue-form',{attrs:{"defaults":_vm.defaults,"option":_vm.option},on:{"update:defaults":function($event){_vm.defaults=$event},"submit":_vm.submit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }